// 交易明细

import { HttpTransationRecord } from '@/service/billing';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList,mixin],
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            // Tabs: {show: true},
            formData:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            // Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpTransationRecord,
        handleOperates(params="", type,batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/funding/transactionRecord/export",this.formData,
                        {executor:'request',download:true}
                    );
                    break;
            }
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getSysorgList']),
        ToolsData(){
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return  [
                {
                    label: this.$t('fbb.bill.abnormal_createdat', { defaultValue: '交易时间' }),
                    key: 'BT_updatedAt',
                    show: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('erp.product_channel.type', { defaultValue: '类型' }),
                    key: 'EQ_type',
                    show:true,
                    tag: 'vSelect',
                    options:this.getBillType
                },
                {
                    label: this.$t('fbb.adjustment.list_secondcategory', { defaultValue: '二级分类' }),
                    key: 'EQ_category',
                    show:true,
                    tag: 'vSelect',
                    options:this.getCategory
                },
                {
                    label: this.$t('global.common.order_no', { defaultValue: '单号' }),
                    key: 'EQ_extraOrderNo',
                    tag: 'vInput',
                },
            ]
        },
        columns() {
            return [
            {
                title: this.$t('fbb.bill.abnormal_createdat', { defaultValue: '交易时间' }),
                key: 'updatedAt',
            }, {
                title: this.$t('erp.product_channel.type', { defaultValue: '类型' }),
                key: 'type',
                render: (h, { row }) => this.findRenderLabel(this.getBillType, row.type)
            }, 
            {
                title: this.$t('fbb.adjustment.list_secondcategory', { defaultValue: '二级分类' }),
                key: 'category',
                render: (h, { row }) => this.findRenderLabel(this.getCategory, row.category)
            }, 
            {
                title: this.$t('global.common.order_no', { defaultValue: '单号' }),
                key: 'extraOrderNo',
            }, 
            {
                title: this.$t('fbb.bill.abnormal_amount', { defaultValue: '交易金额' }),
                key: 'amount',
            }, 
            {
                title: this.$t('erp.product.currency', { defaultValue: '币种' }),
                key: 'currency',
                render(h,{row}){
                    return row.currency||'USD'
                }
            },
            {
                title: this.$t('erp.product.currency', { defaultValue: '说明' }),
                key: 'remark',
            }];
        },
    },
};




